"use strict";
window._theme = window._theme || {};
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab');
  const tabPanels = document.querySelectorAll('.tab-content');

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t, idx) => {
        t.classList.toggle('active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        t.setAttribute('tabindex', t === tab ? '0' : '-1');
        tabPanels[idx].classList.toggle('active', t === tab);
        tabPanels[idx].toggleAttribute('hidden', t !== tab);
      });
    });
    tab.addEventListener('keydown', (e) => {
      let idx = Array.prototype.indexOf.call(tabs, tab);
      if (e.key === 'ArrowRight') {
        tabs[(idx + 1) % tabs.length].focus();
      } else if (e.key === 'ArrowLeft') {
        tabs[(idx - 1 + tabs.length) % tabs.length].focus();
      } else if (e.key === 'Home') {
        tabs[0].focus();
      } else if (e.key === 'End') {
        tabs[tabs.length - 1].focus();
      }
    });
  });

  document.querySelectorAll('.tab-content').forEach(panel => {
    panel.addEventListener('click', function(e) {
      const header = e.target.closest('.accordion-header');
      if (header) {
        const item = header.closest('.accordion-item');
        const content = document.getElementById(header.getAttribute('aria-controls'));
        const expanded = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', !expanded);
        item.classList.toggle('active', !expanded);
        content.toggleAttribute('hidden', expanded);
      }
    });
    panel.addEventListener('keydown', function(e) {
      if (e.target.classList.contains('accordion-header')) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.target.click();
        }
      }
    });
  });
})